import ProtectedRoute from "routes/ProtectedRoute";
import { protectedRouteLoader } from "routes/loaders/protectedRouteLoader";

export const engagementRoutes = [
  {
    path: "speaking-invitations",
    loader: protectedRouteLoader,
    lazy: async () => {
      const [layoutMod, errorMod] = await Promise.all([
        import("components/UI/AdminLayout"),
        import("views/ErrorPage"),
      ]);

      const AdminLayout = layoutMod.default;
      const ErrorPage = errorMod.default;

      return {
        Component: () => (
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        ),
        ErrorBoundary: ErrorPage,
      };
    },
    children: [
      {
        index: true,
        lazy: async () => {
          const mod =
            await import("views/Admin/Engagement/speaking-invitation");
          const SpeakingInvitation = mod.default;
          return {
            Component: () => <SpeakingInvitation />,
          };
        },
      },
      {
        path: ":id",
        lazy: async () => {
          const mod =
            await import("views/Admin/Engagement/speaking-invitation-details");
          const SpeakingInvitationDetails = mod.default;
          return {
            Component: () => <SpeakingInvitationDetails />,
          };
        },
      },
    ],
  },
];
